(function tableOfContentsArticle () {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "table-of-contents-article";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


    const generateToc = GlobalSite.checkDependency("GlobalSite.generateToc");

  $(() => {
    generateToc({
      contentSelector: "#article-content",
      tocContainerSelector: "#table-of-contents",
      tocListSelector: "#table-of-contents-list"
    });
  })
})()